import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface CustomerInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Sets `aria-invalid`; the matching message lives in CustomerFormField. */
  invalid?: boolean;
}

/**
 * User Profile P2 — the one text input for customer screens. The class list is
 * the exact one the login and activation pages had inlined (44px tall, tokens
 * only, visible focus, disabled state); lifting it here keeps the three forms
 * identical without touching the pages that already ship it.
 */
export const CustomerInput = forwardRef<HTMLInputElement, CustomerInputProps>(
  function CustomerInput({ invalid, className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'flex h-11 w-full rounded-lg border border-customer-border bg-customer-surface px-3 py-2 text-sm text-customer-text placeholder:text-customer-text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-customer-ring focus:border-customer-primary disabled:cursor-not-allowed disabled:opacity-50',
          invalid && 'border-customer-danger/60',
          className,
        )}
        {...rest}
      />
    );
  },
);
